// extracted by mini-css-extract-plugin
module.exports = {"submenu":"style_submenu__uDzDS","submenuItem":"style_submenu-item__v_GDZ"};